// aws-config-attachments.js
import AWS from 'aws-sdk';

const s3TemplateUploader = new AWS.S3({
  accessKeyId: 'AKIAVXGA6A4KYUSGF3JR', // Replace with the new user's Access Key ID
  secretAccessKey: 'cqebzu0+G1xLxECgZcEVbcYEtAXJgmUHoEkqNGyR', // Replace with the new user's Secret Access Key
  region: 'ap-southeast-1' // Replace with your S3 bucket's region
});

export default s3TemplateUploader;
